import { useAppStore } from "../../store/useAppStore";

export function SyncBadge({ className = "" }: { className?: string }) {
  const isOnline = useAppStore((s) => s.demo.isOnline);
  const queue = useAppStore((s) => s.syncQueue);
  const queuedCount = queue.filter((q) => q.status === "queued").length;
  const syncingCount = queue.filter((q) => q.status === "syncing").length;

  let label: string;
  let dotClass: string;
  if (!isOnline) {
    label = queuedCount > 0 ? `Offline · ${queuedCount} queued` : "Offline";
    dotClass = "bg-automation";
  } else if (syncingCount > 0) {
    label = `Syncing ${syncingCount}…`;
    dotClass = "bg-primary animate-pulse";
  } else {
    label = "Synced";
    dotClass = "bg-success";
  }

  return (
    <span className={`inline-flex items-center gap-1.5 font-mono text-[11px] font-medium ${className}`} role="status" aria-live="polite">
      <span className={`h-1.5 w-1.5 rounded-full ${dotClass}`} aria-hidden="true" />
      {label.toUpperCase()}
    </span>
  );
}
